import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    user: {},
    token: localStorage.getItem('token') || '',
  },
  getters: {
    user: state => state.user,
    isLoggedIn: state => !!state.token,
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, token){
      state.status = 'success'
      state.token = token
    },
    user(state, user){
      state.user = user
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = ''
      state.token = ''
    },
  },
  actions: {
    me({commit}){
      return new Promise((resolve, reject) => {
        Vue.axios({url: '/auth/me', method: 'POST' })
            .then(resp => {
              commit('user', resp.data)
            })
            .catch(err => {
              commit('auth_error', err)
              localStorage.removeItem('token')
              reject(err)
            })
      })
    },
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        Vue.axios({url: '/auth/login', data: user, method: 'POST' })
            .then(resp => {
              const token = resp.data.access_token

              localStorage.setItem('token', token)
              //axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              commit('auth_success', token)
              resolve(resp)
            })
            .catch(err => {
              commit('auth_error')
              localStorage.removeItem('token')
              reject(err)
            })
      })
    },
    logout({commit}) {
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('token')
        delete Vue.axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
  },
  modules: {
  }
})
